import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Card , CardHeader, CardContent, Typography, TextField, Checkbox,TextareaAutosize, fabClasses} from '@mui/material';
import Table from 'react-bootstrap/Table';
import {Button} from "react-bootstrap";
import { Pagination } from "react-bootstrap";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { fetchMaterials } from "assets/globalAPI/apiGlobal";
import { approveMaterial } from "assets/globalAPI/apiGlobal";
import { createMaterial } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchRoleMaster } from "assets/globalAPI/apiGlobal";
import { createRoleMaster } from "assets/globalAPI/apiGlobal";

const RoleMasterView = () => {
 const toastId = React.useRef(null);
 const [isActive, setIsActive] = useState(false);
 const navigate = useNavigate();
 const capitalizeHeader = (header) => {
    return header
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  };

   const [currentPage, setCurrentPage]= useState(1);
   const [totalPages, setTotalPages]= useState(1);
   const [roles, setRoles] = useState([]); // Stores fetched roles
  const [selectedRole, setSelectedRole] = useState(null); // Currently selected role
  const [roleName, setRoleName] = useState("");
  const [materialView, setMaterialView]= useState(0);
  const [materialCreate, setMaterialCreate]= useState(0);
  const [materialApproval, setMaterialApproval]= useState(0);
  const [customerView, setCustomerView]= useState(0);
  const [customerApproval, setCustomerApproval]= useState(0);
  const [customerEdit, setCustomerEdit]= useState(0);
  const [vendorView, setVendorView]= useState(0);
  const [vendorApproval, setVendorApproval]= useState(0);
  const [vendorEdit, setVendorEdit]= useState(0);
  const [openDialog, setOpenDialog]= useState(false)
  const [permissions, setPermissions] = useState({
    customer_view: 0,
    customer_approval: 0,
    material_view: 0,
    material_approval: 0,
    vendor_view: 0,
    vendor_approval: 0,
  });

  const fetchRoles = async () => {
    setIsActive(true)
    const body={
      page:currentPage,
    }
    try {
      const response = await fetchRoleMaster(body); // Replace with your API
      const res= response.data;
      if(res.status){
          setRoles(res.data);
        console.log("Roles fetched successfully:", res);
        setTotalPages(res.totalPages)
        setIsActive(false)
      }else{
        console.log("Roles not fetched>> ", res)
        setIsActive(false)
      }
    } catch (error) {
        setIsActive(false)
      console.error("Error fetching roles:", error);
      if(error.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    }
  };

  useEffect(() => {
    fetchRoles()
  }, [currentPage]);

  const handleOpenDialog = (user) => {
  setSelectedRole(user)
  setRoleName(user.role_name);
  setMaterialView(user.material_view);
  setMaterialApproval(user.material_approval);
  setMaterialCreate(user.material_create);
  setVendorView(user.vendor_view);
  setVendorApproval(user.vendor_approval);
  setCustomerView(user.customer_view);
  setCustomerApproval(user.customer_approval)

    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRole(null);
  };

   const handleSave = async (e) => {
    e.preventDefault();
      setIsActive(true)
  
      // Remove role_id before sending
     
  
      const body={
          role_name:roleName,
          customer_view: customerView,
      customer_approval: customerApproval,
      customer_edit: customerEdit,
      material_view: materialView,
      material_approval: materialApproval,
      material_create: materialCreate,
      vendor_view: vendorView,
      vendor_approval: vendorApproval,
      vendor_edit: vendorEdit,
      }
  
      console.log("Sending Payload:", body); // Debugging
  
      try {
        const response = await createRoleMaster(body)
          const res= response.data;
          if(res.status){
              console.log("what went in body>> ", body)
              console.log("Role created successfully:", res);
              setIsActive(false)
              if(!toast.isActive(toastId.current)){
                          toastId.current= toast.success(res.message,{
                          className:"small-toast"
                          })
                      }
                      setOpenDialog(false);
                      fetchRoles();
          }else{
              console.log("Role not created>> ", res)
              setIsActive(false)
              if(!toast.isActive(toastId.current)){
                          toastId.current= toast.warning(res.message,{
                          className:"small-toast"
                          })
          }
          setOpenDialog(false);
                      fetchRoles();
      }
      } catch (error) {
        console.error("Error updating permissions:", error);
        setIsActive(false)
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
            localStorage.clear();
          },2000)
          return;
        }
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.warning(error.message,{
          className:"small-toast"
          })
  }
      }
    };

    const handlePageChange=(p)=>{
        setCurrentPage(p)
        
      }

//   const handleRoleChange = (selected) => {
//     const role = roles.find((r) => r.role_id === selected.value);
//     if (role) {
//       setSelectedRole(role.role_name);
//       setPermissions({ ...role });
//     }
//   };

// const handleCheckboxChange = (field) => {
//     setPermissions((prev) => {
//         const updatedPermissions = { ...prev };

//         // Toggle the clicked checkbox
//         updatedPermissions[field] = updatedPermissions[field] ? 0 : 1;

//         // If the changed field is an "approval" checkbox, ensure "view" is also checked
//         if (field.includes("_approval") && updatedPermissions[field] === 1) {
//             const viewField = field.replace("_approval", "_view"); // Get corresponding view field
//             updatedPermissions[viewField] = 1;
//         }

//         // If the changed field is a "view" checkbox and it gets unchecked, also uncheck "approval"
//         if (field.includes("_view") && updatedPermissions[field] === 0) {
//             const approvalField = field.replace("_view", "_approval"); // Get corresponding approval field
//             updatedPermissions[approvalField] = 0;
//         }

//         return updatedPermissions;
//     });
// };



//   const handleSave = async () => {
//     setIsActive(true)
    
//     if (!roleName.trim()) {
//         if(!toast.isActive(toastId.current)){
//                                     toastId.current= toast.error("Please Enter A Role Name",{
//                                     className:"small-toast"
//                                     })
//                                 }
//         setIsActive(false);
//         return;
//     }

//     // Remove role_id before sending
//     const { role_id, ...payload } = permissions;
//     payload.role_name = roleName;  

//     const body={
//         role_name:roleName,
//         customer_view: permissions.customer_view,
//     customer_approval: permissions.customer_approval,
//     material_view: permissions.material_view,
//     material_approval: permissions.material_approval,
//     vendor_view: permissions.vendor_view,
//     vendor_approval: permissions.vendor_approval,
//     }

//     console.log("Sending Payload:", body); // Debugging

//     try {
//       const response = await createRoleMaster(body)
//         const res= response.data;
//         if(res.status){
//             console.log("what went in body>> ", body)
//             console.log("Role created successfully:", res);
//             setIsActive(false)
//             if(!toast.isActive(toastId.current)){
//                         toastId.current= toast.success(res.message,{
//                         className:"small-toast"
//                         })
//                     }
//                     setRoleName("");
//                     setPermissions({
//                         customer_view: 0,
//                         customer_approval: 0,
//                         material_view: 0,
//                         material_approval: 0,
//                         vendor_view: 0,
//                         vendor_approval: 0,
//                     });
//         }else{
//             console.log("Role not created>> ", res)
//             setIsActive(false)
//             if(!toast.isActive(toastId.current)){
//                         toastId.current= toast.warning(res.message,{
//                         className:"small-toast"
//                         })
//         }
//     }
//     } catch (error) {
//       console.error("Error updating permissions:", error);
//       setIsActive(false)
//       if(error.response?.status==403){
//         if(!toast.isActive(toastId.current)){
//           toastId.current= toast.error("Your Session has expired",{
//             className:"small-toast"
//           })
//         }
//         setTimeout(()=>{
//           navigate("/")
//         },2000)
//         return;
//       }
//       if(!toast.isActive(toastId.current)){
//         toastId.current= toast.warning(res.message,{
//         className:"small-toast"
//         })
// }
//     }
//   };

   return(
    <DashboardLayout>
        <DashboardNavbar/>
        <ToastContainer />
        <SimpleBackdrop openLoader={isActive}/>
        
    <div style={{overflowX:'auto', marginTop:'10px'}}>
      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
        <thead>
          <tr style={{ color: "white", backgroundColor: "#3498db" }}>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              MODULE
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              CUSTOMER VIEW
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              CUSTOMER APPROVAL
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              CUSTOMER EDIT
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              MATERIAL VIEW
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              MATERIAL APPROVAL
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              VENDOR VIEW
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              VENDOR APPROVAL
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              VENDOR EDIT
            </th>
            <th style={{ backgroundColor: "#FF2C2C", color: "#FFFFF0" }}>
              ACTION
            </th>
          </tr>
        </thead>
        <tbody>
          {roles.map((module) => (
            <tr key={module} style={{ fontSize: "12px" }}>
              <td>{module.role_name.toUpperCase()}</td>
              <td>
               {module.customer_view===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.customer_approval===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.customer_edit===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.material_view===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.material_approval===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.vendor_view===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.vendor_approval===1 ? "YES" : "NO"}
              </td>
              <td>
                {module.vendor_edit===1 ? "YES" : "NO"}
              </td>
             <td >
                                              <SoftButton variant="text" color="primary" onClick={() => handleOpenDialog(module)}>
                                              <Icon>visibility</Icon>
                                            </SoftButton>
                                            </td>
            </tr>
          ))}
        </tbody>
      </Table>
</div>
        <Pagination className="mt-3">
                                  <Pagination.Prev
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    style={{
                                      color: "danger",
                                      borderRadius: "5px",
                                    }}
                                  />
                                
                                  {/* Always show first page */}
                                  <Pagination.Item
                                    active={currentPage === 1}
                                    onClick={() => handlePageChange(1)}
                                    style={{
                                      color: currentPage === 1 ? "#fff" : "danger",
                                      backgroundColor: currentPage === 1 ? "danger" : "transparent",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    1
                                  </Pagination.Item>
                                
                                  {/* Left dots */}
                                  {currentPage > 3 && <Pagination.Ellipsis disabled />}
                                
                                  {/* Middle page numbers */}
                                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(
                                      (page) =>
                                        page !== 1 &&
                                        page !== totalPages &&
                                        Math.abs(currentPage - page) <= 1
                                    )
                                    .map((page) => (
                                      <Pagination.Item
                                        key={page}
                                        active={page === currentPage}
                                        onClick={() => handlePageChange(page)}
                                        style={{
                                          color: page === currentPage ? "#fff" : "danger",
                                          backgroundColor: page === currentPage ? "danger" : "transparent",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        {page}
                                      </Pagination.Item>
                                    ))}
                                
                                  {/* Right dots */}
                                  {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}
                                
                                  {/* Always show last page */}
                                  {totalPages > 1 && (
                                    <Pagination.Item
                                      active={currentPage === totalPages}
                                      onClick={() => handlePageChange(totalPages)}
                                      style={{
                                        color: currentPage === totalPages ? "#fff" : "danger",
                                        backgroundColor:
                                          currentPage === totalPages ? "danger" : "transparent",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      {totalPages}
                                    </Pagination.Item>
                                  )}
                                
                                  <Pagination.Next
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    style={{
                                      color: "danger",
                                      borderRadius: "5px",
                                    }}
                                  />
                                </Pagination>

      <Dialog
                                  open={openDialog}
                                  onClose={handleCloseDialog}
                                  fullScreen
                                  maxWidth="md"
                                  fullWidth
                                >
                                    <DialogTitle>
                                              <div style={{display:'flex', justifyContent:'space-between'}}>
                                    
                                    
                                              <span style={{fontSize: "25px"}}>Role Details</span>
                                              {/* <SoftBox display="flex" justify-content= "space-between" gap={2}>
                                                <SoftButton  onClick={()=>setEdit(true)}  variant="contained" color="info">
                                                                Edit
                                                              </SoftButton>
                                              </SoftBox> */}
                                                
                                              </div>
                                              
                                            </DialogTitle>

                                             <DialogContent>
                                             <SimpleBackdrop openLoader={isActive}/>
                                                
                                                    <form noValidate onSubmit={handleSave}>
                                                        {selectedRole &&
                                                        
                                                        <SoftBox py={3} className="customerblock">
                                                            <Grid container spacing={3}>
                                                                 <Grid item xs={12} lg={12}>
                                                                    <Card sx={{ overflow: "visible" }}>
                                                                          <SoftBox p={3}>
                                                                            <SoftBox mt={1}>
                                                                                <Grid container spacing={3}>
                                                                                  
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Role Name
                                                                                                 </SoftTypography>
                                                                                                  <SoftInput
                                                                                                  readOnly
                                                                                                  onChange={(e)=>setRoleName(e.target.value)}
                                                                                                  value={roleName}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>

                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Material View
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                  options={[
                                                                                                    {value: 1,label: "Yes"},
                                                                                                    {value: 0, label: "No"}
                                                                                                  ]}
                                                                                                  
                                                                                                  onChange={(e)=>setMaterialView(e.value)}
                                                                                                  value={[
                                                                                                    {value: materialView, label:  materialView==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Material Create
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                   options={[
                                                                                                    {value: 1,label: "Yes"},
                                                                                                    {value: 0, label: "No"}
                                                                                                  ]}
                                                                                                  onChange={(e)=>setMaterialCreate(e.value)}
                                                                                                  value={[
                                                                                                    {value: materialCreate, label:  materialCreate==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Material Approve
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                   
                                                                                                  onChange={(e)=>setMaterialApproval(e.value)}
                                                                                                  value={[
                                                                                                    {value: materialApproval, label:  materialApproval==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]} 
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Customer View
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                   options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]} 
                                                                                                  onChange={(e)=>setCustomerView(e.value)}
                                                                                                  value={[
                                                                                                    {value: customerView, label:  customerView==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Customer Approval
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                  
                                                                                                  onChange={(e)=>setCustomerApproval(e.value)}
                                                                                                  value={[
                                                                                                    {value: customerApproval, label:  customerApproval==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]}  
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Customer Edit
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                  
                                                                                                  onChange={(e)=>setCustomerEdit(e.value)}
                                                                                                  value={[
                                                                                                    {value: customerEdit, label:  customerEdit==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]}  
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Vendor View
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                  
                                                                                                  onChange={(e)=>setVendorView(e.value)}
                                                                                                  value={[
                                                                                                    {value: vendorView, label:  vendorView==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]}  
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Vendor Approval
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                  
                                                                                                  onChange={(e)=>setVendorApproval(e.value)}
                                                                                                  value={[
                                                                                                    {value: vendorApproval, label:  vendorApproval==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]}  
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Vendor Edit
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                  
                                                                                                  onChange={(e)=>setVendorEdit(e.value)}
                                                                                                  value={[
                                                                                                    {value: vendorEdit, label:  vendorEdit==0? "No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                   
                                                                                                  ]}  
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                </Grid>

                                                                                <Grid container spacing={3}>
                                                                                 <Grid item xs={12} lg={12}>
                                                                                   <Card sx={{ overflow: "visible" }}>
                                                                                     <SoftBox p={3}>
                                                                                     <Grid container justifyContent="flex-end" mt={2} spacing={2}>
  <Grid item>
    <SoftButton onClick={handleCloseDialog} variant="contained" color="primary">
      Close
    </SoftButton>
  </Grid>
  <Grid item>
    <SoftButton type="submit" variant="contained" color="success">
      Submit
    </SoftButton>
  </Grid>
</Grid>
                                                                                     </SoftBox>
                                                                                   </Card>
                                                                                 </Grid>
                                                                                </Grid>
                                                                            </SoftBox>
                                                                          </SoftBox>
                                                                    </Card>
                                                                 </Grid>
                                                            </Grid>
                                                        </SoftBox>
                                                        }

                                                        
                                                                                         {/* <SoftBox py={3} className="customerblock">
                                                                                <Grid container spacing={3}>
                                                                                 <Grid item xs={12} lg={12}>
                                                                                   <Card sx={{ overflow: "visible" }}>
                                                                                     <SoftBox p={3}>
                                                                                       <Grid container justifyContent="flex-end" mt={2}>
                                                                                         <Grid item>
                                                                                           <SoftButton onClick={handleCloseDialog} variant="contained" color="primary">
                                                                                             Close
                                                                                           </SoftButton>
                                                                                         </Grid>
                                                                                       </Grid>
                                                                                     </SoftBox>
                                                                                   </Card>
                                                                                 </Grid>
                                                                                </Grid>
                                                                                </SoftBox> */}
                                                    </form>

                                    
                                                
                                             </DialogContent>
                                </Dialog>

    </DashboardLayout>
   )

}

export default RoleMasterView;